// Delete this file when the capital gain changes arrive in the
// trading project
import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import Pagination, { InvalidQueryParam } from '@lib/hundredBricksAPI/pagination';
import { APIError } from '@lib/api';
import OnSaleInvestment from './OnSaleInvestment';
import OnSaleInvestments from './OnSaleInvestments';
import OnSaleInvestmentsError from './OnSaleInvestmentsError';
class OnSaleInvestmentsAPI extends HundredBricksAPI {
    async getOnSaleInvestments(params) {
        try {
            const { data } = await this.client.get('v2/brickInvestments/onSale', { params });
            const pagination = new Pagination(data.pagination);
            const investments = data?.items.map(investment => new OnSaleInvestment(investment));
            return new OnSaleInvestments({ investments, pagination, count: data.count });
        }
        catch (error) {
            const { page, perPage } = params;
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'PAGE_CANNOT_BE_LESS_THAN_ONE':
                        throw new InvalidQueryParam('page', page, { cause: error });
                    case 'PER_PAGE_CANNOT_BE_LESS_THAN_ONE':
                        throw new InvalidQueryParam('perPage', perPage, { cause: error });
                    case 'INVALID_PAGE':
                        throw new InvalidQueryParam('page', page, { cause: error });
                    case 'INVALID_PER_PAGE':
                        throw new InvalidQueryParam('perPage', perPage, { cause: error });
                    default:
                        throw new OnSaleInvestmentsError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new OnSaleInvestmentsError('Unexpected error when obtaining on sale investments', { cause: error });
            }
            else {
                throw new OnSaleInvestmentsError(`Unexpected error when obtaining on sale investments: '${error}'`);
            }
        }
    }
}
export default OnSaleInvestmentsAPI;
